export const USAGE_PIE_DATA = [
	{ name: 'Admin', value: 3, color: '#72DE2F' },
	{ name: 'Business', value: 18, color: '#F93030' },
	{ name: 'Professional', value: 9, color: '#5A6ACF' },
	{ name: 'Basic', value: 13, color: '#F99C30' },
];

export const USERS_HIERARCHY_PIE_DATA = [
	{ name: 'Admin', value: 2, color: '#72DE2F' },
	{ name: 'Sub-admin', value: 2, color: '#F93030' },
	{ name: 'Gestor', value: 8, color: '#5A6ACF' },
	{ name: 'Consultor', value: 7, color: '#F99C30' },
	{ name: 'Agricultor', value: 14, color: '#00FFF2' },
];

export const SUBSCRIBERS_PIE_DATA = [
	{ name: 'Basic', value: 42, color: '#F99C30' },
	{ name: 'Professional', value: 21, color: '#72DE2F' },
	{ name: 'Enterprise', value: 12, color: '#5A6ACF' },
];

export const SUBSCRIBERS_LINE_DATA = [
	{ day: '01', atual: 4, anterior: 3 },
	{ day: '02', atual: 6, anterior: 5 },
	{ day: '03', atual: 5, anterior: 7 },
	{ day: '04', atual: 8, anterior: 6 },
	{ day: '05', atual: 7, anterior: 9 },
	{ day: '06', atual: 9, anterior: 8 },
];
